import { useFlag } from '@calendly/feature-check-react'
import { useEffect } from 'react'

import { TRACKING_EVENT_NAMES } from './constants'
import { useTrack } from './useTrack'

const trackV2Hits = {}

const checkHit = (key) => {
  if (trackV2Hits[key]) { return true }

  trackV2Hits[key] = true

  return false
}

export const useFFTrackingV2 = (flagKey) => {
  const flagStatus = useFlag(flagKey, false)
  const track = useTrack()

  useEffect(() => {
    if (flagStatus && !checkHit(flagKey)) {
      track({
        name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
        properties: {
          flag_key: flagKey,
          rule: 'targeted_delivery',
          source: 'frontend',
          variation_key: 'on'
        }
      })
    }
  })

  return flagStatus
}
